document.addEventListener("teeinblue-event-component-injected", function () {
  const formInputs = productForm.querySelector("#teeFormInputs");
  const inputsTitle = document.createElement("div");
  inputsTitle.classList.add("formInputsTitle");
  inputsTitle.textContent = "Personalize product";
  formInputs.insertAdjacentElement("beforebegin", inputsTitle);

  const countdownHTML = `
    <div class="product-form__countdown">
      <div class="product-form__countdown--info">
        <span>
          <b>Flash Sale:</b> This item is selling out fast! 🔥
        </span>
      </div>
    </div>
    <div class="product-form__stock-bar">
      <label class="product-form__stock-bar--label lol" for="stock_bar" style="color: #bf1112;">Limited stock</label>
      <progress class="product-form__stock-bar--progress" id="stock_bar" value="10" max="100"></progress>
    </div>`;

  const teeFormActions = document.querySelector(".tee-product-price");
  if (teeFormActions) {
    const newElement = document.createElement("div");
    newElement.innerHTML = countdownHTML;
    teeFormActions.insertAdjacentElement("afterend", newElement);
  }

  setInterval(function () {
    if (
      document
        .querySelector(".tee-price--saving")
        .querySelectorAll(".money.theme-money.price")
    ) {
      var compare_price = document.querySelector(
        ".money.theme-money.price.tee-price--compare"
      ).innerHTML;
      var regular_price = document.querySelector(
        ".money.tee-price--current"
      ).innerHTML;

      // compare_price = compare_price.replace("$", "");
      // regular_price = regular_price.replace("$", "");
      compare_price = compare_price.replace(/[^\d.]/g, "");
      regular_price = regular_price.replace(/[^\d.]/g, "");

      var precent =
        ((parseFloat(compare_price) - parseFloat(regular_price)) /
          parseFloat(compare_price)) *
        100;

      document
        .querySelector(".tee-price--saving")
        .querySelectorAll(".money.theme-money.price")[0].innerHTML =
        parseInt(precent) + "%";
    }
  }, 200);
});

document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});

$(document).ready(function () {
  $(".accordion-heading").click(function () {
    $(this).toggleClass("active");
    $(this).parent().find(".arrow").toggleClass("arrow-animate");
    $(this).parent().find(".content-accordions").slideToggle(280);
  });
});
